import React from "react";
import {
  StyledBottomSheetContent,
  StyledNumber,
  StyledParagraph,
} from "./_.styled";
import {
  Anchor,
  BottomSheet,
  Type,
} from "discover.medical.react-component-library";

const EvidenceBottomSheet = ({
  isBottomOpen,
  setIsBottomOpen,
  loeBrochureUrl,
}) => {
  return (
    <BottomSheet
      isOpen={isBottomOpen}
      closeable={true}
      onClose={() => setIsBottomOpen(false)}
      transition="slide"
      speed={1000}
      data-testid="dynamed-badge-bottom-sheet"
      maxHeight={"85%"}
    >
      <StyledBottomSheetContent>
        <Type element="h3" fontFamily="secondary" paddingBottom="xl">
          DynaMed Levels of Evidence
        </Type>
        <Type element="h4" fontFamily="secondary" paddingBottom="xl">
          Quickly find and determine the quality of the evidence.
        </Type>
        <Type element="p">
          DynaMed provides easy-to-interpret Level of Evidence labels so users
          can quickly find and determine the quality of the best available
          evidence. Evidence may be labeled in one of three levels:
        </Type>
        <Type element="h6" paddingBottom="sm">
          <span>
            <StyledNumber>1</StyledNumber>
            Level 1 (likely reliable) Evidence
          </span>
        </Type>
        <div>
          <StyledParagraph>
            Representing research results addressing clinical outcomes and
            meeting an extensive set of quality criteria which minimizes bias.
          </StyledParagraph>
          <StyledParagraph>
            There are two types of conclusions which can earn a Level 1 label:
            levels of evidence for conclusions derived from individual studies
            and levels of evidence for conclusions regarding a body of evidence.
          </StyledParagraph>
        </div>

        <Type element="h6" paddingBottom="sm">
          <span>
            <StyledNumber>2</StyledNumber>
            Level 2 (mid-level) Evidence
          </span>
        </Type>
        <StyledParagraph>
          Representing research results addressing clinical outcomes, and using
          some method of scientific investigation, but not meeting the quality
          criteria to achieve Level 1 evidence labeling.
        </StyledParagraph>

        <Type element="h6" paddingBottom="sm">
          <span>
            <StyledNumber>3</StyledNumber>
            Level 3 (lacking direct) Evidence
          </span>
        </Type>
        <StyledParagraph>
          Representing reports that are not based on scientific analysis of
          clinical outcomes. Examples include case series, case reports, expert
          opinion, and conclusions extrapolated indirectly from scientific
          studies.
        </StyledParagraph>
        <Type element="h4" fontFamily="secondary">
          Grades of Recommendation
        </Type>
        <Type element="p">
          Guideline producers are now frequently using classification approaches
          for their evidence and recommendations, and these classifications are
          recognized and requested by guideline users. When summarizing
          guideline recommendations for DynaMed users, the DynaMed Editors are
          using the guideline-specific classifications and providing guideline
          classification approach when this is done.
        </Type>
        <Anchor target="_blank" rel="noreferrer noopener" href={loeBrochureUrl}>
          Download the full version of Levels of Evidence
        </Anchor>
      </StyledBottomSheetContent>
    </BottomSheet>
  );
};

EvidenceBottomSheet.displayName = "EvidenceBottomSheet";

export default EvidenceBottomSheet;
